import React from "react"
import { Card } from "antd"

const ProjectSummary = () => {
  const vehicleCount = 25

  const totals = {
    grandTotal: 250000,
    fleetTotal: 6250000,
    systemTotals: {
      engine: 80000,
      transmission: 60000,
      battery: 40000,
      electronics: 30000,
    },
  }

  const systems = [
    { id: "engine", name: "Engine", color: "#f5222d" },
    { id: "transmission", name: "Transmission", color: "#fa8c16" },
    { id: "battery", name: "Battery", color: "#52c41a" },
    { id: "electronics", name: "Electronics", color: "#1890ff" },
  ]

  return (
    <div className="project-summary">
      <div className="project-summary-stats">
        <Card className="project-summary-card" bordered={false}>
          <div className="project-summary-label">Cost per Vehicle</div>
          <div className="project-summary-value red">
            €{(totals.grandTotal / vehicleCount).toFixed(2)}
          </div>
        </Card>
        <Card className="project-summary-card" bordered={false}>
          <div className="project-summary-label">Fleet Size</div>
          <div className="project-summary-value muted">
            {vehicleCount} vehicles
          </div>
        </Card>
        <Card className="project-summary-card" bordered={false}>
          <div className="project-summary-label">Total Project Cost</div>
          <div className="project-summary-value muted">
            €{totals.fleetTotal.toFixed(2)}
          </div>
        </Card>
      </div>

      <Card className="project-summary-breakdown">
        <h3>Cost Breakdown by System</h3>
        <p className="project-summary-muted">
          Detailed cost analysis per vehicle system
        </p>
        <div className="project-summary-breakdown-list">
          {systems.map((system) => (
            <div key={system.id} className="project-summary-breakdown-item">
              <div className="project-summary-left">
                <span
                  className="project-summary-dot"
                  style={{ backgroundColor: system.color }}
                ></span>
                <span className="project-summary-system-name">
                  {system.name}
                </span>
              </div>
              <div className="project-summary-right">
                <span className="project-summary-price">
                  €{totals.systemTotals[system.id]?.toFixed(2)}
                </span>
                <span className="project-summary-per">per vehicle</span>
              </div>
            </div>
          ))}
        </div>
      </Card>
    </div>
  )
}

export default ProjectSummary